{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Şablonlar",
    "DESCRIPTION": "WhatsApp gelen kutularınızdan senkronize edilen mesaj şablonlarını görüntüleyin. Bir şablon oluşturmak veya düzenlemek için sağlayıcınız üzerinden yönetin.",
    "COUNT": "{n} şablon | {n} şablon",
    "LEARN_MORE": "WhatsApp şablonları hakkında daha fazla bilgi edinin",
    "SYNC_TEMPLATES": "Şablonları senkronize et",
    "SYNC_SUCCESS": "Tüm WhatsApp gelen kutuları için şablon senkronizasyonu başlatıldı. Güncellemeler birkaç dakika sürebilir.",
    "PARTIAL_SYNC_ERROR": "Bazı WhatsApp gelen kutuları için şablon senkronizasyonu başlatıldı, ancak diğerleri senkronize edilemedi.",
    "SYNC_ERROR": "Şablon senkronizasyonu başlatılamadı. Lütfen tekrar deneyin.",
    "SEARCH_PLACEHOLDER": "İçeriğe veya ada göre ara...",
    "MANAGE_IN_META": "Meta'da yönet",
    "LOADING": "WhatsApp şablonları yükleniyor...",
    "EMPTY": "WhatsApp şablonu bulunamadı.",
    "NO_RESULTS": "Filtrelerinizle eşleşen şablon yok.",
    "FETCH_ERROR": "WhatsApp şablonları yüklenemedi. Lütfen tekrar deneyin.",
    "PARTIAL_FETCH_ERROR": "Bazı WhatsApp şablonları yüklenemedi. Lütfen tekrar deneyin.",
    "LAST_SYNC_ATTEMPT": "Son senkronizasyon denemesi: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "WhatsApp onayına gönderilmedi"
    },
    "FILTERS": {
      "ALL_INBOXES": "Tüm gelen kutuları",
      "ALL_LANGUAGES": "Tüm diller",
      "ALL_TYPES": "Tüm türler"
    },
    "TYPES": {
      "TEXT": "Metin",
      "IMAGE": "Görsel",
      "VIDEO": "Video",
      "DOCUMENT": "Belge",
      "CALL_TO_ACTION": "Eyleme geçirme",
      "COPY_CODE": "Kodu kopyala"
    },
    "PREVIEW": {
      "TITLE": "Şablon önizleme",
      "DESCRIPTION": "Bu şablonun WhatsApp'ta nasıl göründüğünü önizleyin.",
      "OPEN": "{name} önizlemesi",
      "CLOSE": "Önizlemeyi kapat",
      "DETAILS": "Şablon ayrıntıları",
      "STATUS": "Durum",
      "TYPE": "İçerik türü",
      "CATEGORY": "Kategori",
      "LANGUAGE": "Dil",
      "INBOXES": "Gelen kutuları"
    }
  }
}
